import { useState, useEffect } from 'react';

const useNativeApp = () => {
  const [isNativeApp, setIsNativeApp] = useState(false);

  useEffect(() => {
    const checkPlatform = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /heliosreport/.test(userAgent) || window.isNativeApp;
    };
    setIsNativeApp(checkPlatform());
  }, []);

  return {isNativeApp};
};

export default useNativeApp;